<!-- 个人信息清单 -->
<template>
  <div>
    <div class="person-Info">
      <div class="text-offset-2 top-space">
        中保车服将尽全力保护您的个人安全，并保障您再个人信息处理过程中的相关权益。为了向您提供大虾师傅的基本功能及附加功能，我们需要收集您在使用服务时通过您主动授权/提供等方式产生的个人信息。以下我们将逐一说明收集情况，方便您快速查阅。
      </div>
      <div class="title-wrap">1、用户基本信息</div>
      <div>
        <p class="type-wrap top">头像</p>
        <div class="content-wrap">
          <div class="left">使用目的</div>
          <div class="right">用于完善网络身份标识</div>
        </div>
        <div class="content-wrap">
          <div class="left">使用场景</div>
          <div class="right">注册、个人信息展示</div>
        </div>
        <div class="content-wrap">
          <div class="left">收集情况</div>
          <div
            class="right"
          >用户提供，已收集 <span style="color: #3399ff"> {{ data.total || 0 }}</span>条</div>
        </div>
        <div class="content-wrap bottom-line">
          <div class="left">信息内容</div>
          <div
            class="right-blue"
            @click="detailClick"
          >详情</div>
        </div>
      </div>

      <div>
        <p class="type-wrap">名字</p>
        <div class="content-wrap">
          <div class="left">使用目的</div>
          <div class="right">用于完善网络身份标识</div>
        </div>
        <div class="content-wrap">
          <div class="left">使用场景</div>
          <div class="right">注册</div>
        </div>
        <div class="content-wrap">
          <div class="left">收集情况</div>
          <div class="right">用户提供，已收集<span style="color:#3399ff">{{ data.name ? '1' : '0' }}</span>条</div>
        </div>
        <div class="content-wrap bottom-line">
          <div class="left">信息内容</div>
          <div class="right">{{ data.name || '-' }}</div>
        </div>
      </div>
      <div>
        <p class="type-wrap">手机号</p>
        <div class="content-wrap">
          <div class="left">使用目的</div>
          <div class="right">用于完善网络身份标识</div>
        </div>
        <div class="content-wrap">
          <div class="left">使用场景</div>
          <div class="right">注册、个人信息展示、派单时方便他人联系</div>
        </div>
        <div class="content-wrap">
          <div class="left">收集情况</div>
          <div class="right">用户提供，已收集<span style="color:#3399ff">{{ data.mobile ? '1' : '0' }}</span>条</div>
        </div>
        <div class="content-wrap bottom-line">
          <div class="left">信息内容</div>
          <div class="right">{{ data.mobile || '-' }}</div>
        </div>
      </div>

      <div class="title-wrap">2、用户使用过程信息</div>
      <div>
        <p class="type-wrap top">位置</p>
        <div class="content-wrap">
          <div class="left">使用目的</div>
          <div class="right">用于接收订单及作业回传自身坐标点</div>
        </div>
        <div class="content-wrap">
          <div class="left">使用场景</div>
          <div class="right">接单、作业</div>
        </div>
        <div class="content-wrap">
          <div class="left">收集情况</div>
          <div class="right">用户提供，每5秒定位一次</div>
        </div>
        <div class="content-wrap bottom-line">
          <div class="left">信息内容</div>
          <div class="right">-</div>
        </div>
      </div>

      <div>
        <p class="type-wrap">图片</p>
        <div class="content-wrap">
          <div class="left">使用目的</div>
          <div class="right">用于订单作业或作业结束回传凭证审核</div>
        </div>
        <div class="content-wrap">
          <div class="left">使用场景</div>
          <div class="right">作业、凭证回传</div>
        </div>
        <div class="content-wrap">
          <div class="left">收集情况</div>
          <div class="right">用户提供，每笔订单回传</div>
        </div>
        <div class="content-wrap bottom-line">
          <div class="left">信息内容</div>
          <div class="right">-</div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      closeable
      close-icon="close"
      :style="{height: '50%'}"
    >
      <div class="popup-wrap">
        <div class="title-wrap">{{ data.total }}次</div>
        <div
          v-for="(item, index) in columns"
          :key="index"
          class="item"
        >
          {{ item.infoDate }}
          <span style="padding-left: 30px;">{{ item.times }}次</span>
        </div>
      </div>
    </van-popup>
  </div>

</template>
<script>
import {
  userInfoCollection
} from '@/common/api.js';

export default {
  name: 'PersonInfoList',
  data() {
    return {
      showPicker: false,
      data: {
        collectionList: [],
        mobile: '',
        name: '',
        total: 0
      },
      columns: []
    };
  },
  activated() {
    this.getUserInfoCollection();
  },
  mounted() {
    this.getUserInfoCollection();
  },
  methods: {
    async getUserInfoCollection() {
      try {
        const data = await userInfoCollection({
          infoType: 1
        });
        console.log(data);
        if (data) {
          // this.reportData = data;
          console.log(data);
          this.data = { ...data };
          this.columns = data.collectionList;
        }
      } catch (error) {
        console.log(error);
      }
    },
    onCancel() {
      this.showPicker = false;
    },
    onConfirm() {
      this.showPicker = false;
    },
    detailClick() {
      this.showPicker = true;
    }
  }
};
</script>

<style lang="scss">
  .popup-wrap {
    color: #383838;
    font-size: 14px !important;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    justify-items: center;
    overflow: none;
    margin-bottom: 12px;

    .title-wrap {
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #383838;
      font-weight: 500;
      box-shadow: inset 0pt -1pt 0pt 0pt rgba(230,230,230,1);
    }
    .item {
      font-size: 16px;
      color: #646464;
      padding: 12px 0;
      text-align: center;
    }
  }
</style>

<style lang="scss" scoped>
$indent: 20px;
.text-offset-2 {
  text-indent: $indent;
}

.person-Info {
  background-color: #fff;
  font-size: 15px;
  padding: 12px;
  line-height: 24px;
  color: #383838;

  .top-space {
    margin-top: 16px;
  }

  .title-wrap {
    margin-top: 32px;
    font-weight: 500;
    color: #383838;
    font-size: 16px;
  }

  .type-wrap {
    border-left: 1px solid rgba(129,129,129,1);
    border-right: 1px solid rgba(129,129,129,1);
    height: 32px;
    line-height: 32px;
    padding-left: 16px;
  }

  .top {
    margin-top: 12px;
    border-top: 1px solid rgba(129,129,129,1);
  }

  .content-wrap {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    font-size: 14px;

    border-top: 1px solid rgba(129,129,129,1);
    border-left: 1px solid rgba(129,129,129,1);
    border-right: 1px solid rgba(129,129,129,1);

    .left {
      width: 200px;
      text-align: center;
      padding: 6px 0;

      background-color: rgba(242,242,242,1);
      border-right: 1px solid rgba(129,129,129,1);
    }

    .right {
      width: 100%;
      text-align: left;
      padding: 6px 16px;
      text-align: center;
    }

    .right-blue {
      width: 100%;
      text-align: left;
      padding: 6px 16px;
      text-align: center;
      color:#3399ff;
      text-decoration: underline;
    }

    .importance {
        font-weight: 700;
        color: #3399ff;
    }
  }
  .bottom-line {
    border-bottom: 1px solid rgba(129,129,129,1);
  }

}

</style>
